import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ProjectCarousel, ProjectModal } from './core';
import { projectsData, getFeaturedProjects } from '../../data/projects';
import { useLanguage } from '../../i18n';
import './ProjectsSection.css';

const ProjectsSection = () => {
  const [selectedProject, setSelectedProject] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [visibleSections, setVisibleSections] = useState({});
  const { t } = useLanguage();

  const handleProjectView = (project) => {
    setSelectedProject(project);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedProject(null);
  };

  const toggleSectionVisibility = (sectionId) => {
    setVisibleSections(prev => ({
      ...prev,
      [sectionId]: !prev[sectionId]
    }));
  };

  // Separar projetos principais dos outros
  const sortByStatus = (arr) => {
    // Ordena com 'completed' primeiro e 'in-progress' por último
    const order = { 'completed': 0, 'in-progress': 1, 'planned': 2 };
    return [...arr].sort((a, b) => {
      const aVal = order[a.status] ?? 0;
      const bVal = order[b.status] ?? 0;
      return aVal - bVal;
    });
  };
  const featuredProjects = sortByStatus(getFeaturedProjects());
  const otherProjects = sortByStatus(projectsData.filter(project => !project.featured));

  return (
    <section id="projects" className="projects-section">
      <div className="container">
        <motion.div
          className="section-header"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.4 }}
        >
          <h2 className="section-title">{t('projects.title')}</h2>
          <div className="section-divider"></div>
          <p className="section-subtitle">
            {t('projects.subtitle')}
          </p>
        </motion.div>

        <motion.div
          className="projects-content"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.4, delay: 0.1 }}
        >
          {/* Projetos Principais */}
          <motion.div
            className="project-section featured-projects"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.3 }}
          >
            <ProjectCarousel
              projects={featuredProjects}
              onProjectView={handleProjectView}
              title="🌟 Projetos Principais"
              autoPlay={false}
              cardSize="large"
            />
          </motion.div>

          {/* Outros Projetos */}
          {otherProjects.length > 0 && (
            <motion.div
              className="project-section"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.3, delay: 0.05 }}
            >
              <div className="project-section-header">
                <div className="project-section-info">
                  <h3 className="project-section-title">💼 Outros Projetos</h3>
                  <div className="project-section-count">
                    {otherProjects.length} projetos
                  </div>
                </div>
                <button
                  className="view-projects-btn"
                  onClick={() => toggleSectionVisibility('other')}
                >
                  {visibleSections.other ? 'Ocultar Projetos' : 'Exibir Projetos'}
                </button>
              </div>
              
              <AnimatePresence>
                {visibleSections.other && (
                  <motion.div
                    className="projects-carousel-content"
                    initial={{ opacity: 0, height: 0, marginTop: 0 }}
                    animate={{ opacity: 1, height: 'auto', marginTop: 16 }}
                    exit={{ opacity: 0, height: 0, marginTop: 0 }}
                    transition={{ duration: 0.3, ease: "easeInOut" }}
                  >
                    <ProjectCarousel
                      projects={otherProjects}
                      onProjectView={handleProjectView}
                      autoPlay={false}
                      cardSize="small"
                    />
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>
          )}
        </motion.div>
      </div>

      {isModalOpen && selectedProject && (
        <ProjectModal
          project={selectedProject}
          onClose={handleCloseModal}
        />
      )}
    </section>
  );
};

export default ProjectsSection;